export const SET_PAGE = 'SET PAGE';
export function setPage(page){
	return { type: SET_PAGE, page: parseInt(page, 10)}
}

export const SET_PAGE_TOTAL = 'SET_PAGE_TOTAL';
export function setPageTotal(total){
	return { type: SET_PAGE_TOTAL, total: parseInt(total, 10) }
}



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/actions/page.js